import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Spinner } from 'reactstrap';
import { axiosPost } from '../../utils/AxiosApi';
import { smsSentStatus, URL } from '../../utils/Constants';
import SmsDetails from './SmsDetails';
import ModalWindow from '../UI/ModalWindow';
import swal from "sweetalert";
import { displayErrorAlert } from '../../utils/Utils';
import Pagination from '../UI/Pagination';
import { NepaliDatePicker } from 'nepali-calander';


const ListSMSLog = () => {
  const [smsLogData, setSmsLogData] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [detailLog, setDetailLog] = useState([]);
  const [detailsModal, setDetailsModal] = useState(false);
  const[detailsSentStatus, setDetailsSentStatus] = useState(false);
  const[detailsMessage, setDetailsMessage] = useState("");
  const [smsStatus, setSmsStatus] = useState("");
  const [sentDate, setSentDate] = useState("");
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalSmsCredit, setTotalSmsCredit] = useState(0);
  const[remainingSmsCredit, setRemainingSmsCredit] = useState(0);
  const [disableSmsSend, setDisableSmsSend]  = useState(false);

  useEffect(() => {
    getSmsLog(smsStatus,sentDate,searchText);
  }, [])

  const getSmsLog = (smsStatusParam,sentDateParam,searchTextParam,currentPageProps) => {
    let currentPagevar = currentPageProps || currentPage;
    let offset =
    currentPagevar * parseInt(pageSize) -
    parseInt(pageSize);
    let url = URL.listSmsLog;
    let param = {
      sentStatus: smsStatusParam == "" ? "" : smsStatus,
      sentDate: sentDateParam == "" ? "" :  sentDate,
      searchText: searchTextParam == "" ? "" :  searchText,
      rowCountLimit: pageSize,
      offSet: offset,
    }
    setLoadingSpinner(true);
    axiosPost(url, param, (response) => {
      if (response.status === 200) {
        setSmsLogData(response.data?.data?.smsLogs);
        setTotalRecords(response.data?.data?.totalRecords);
        setTotalSmsCredit(response.data?.data?.totalSmsCredit);
        setRemainingSmsCredit(response.data?.data?.remainingSmsCredit);
        if(!response.data?.data?.totalSmsCredit || !response.data?.data?.remainingSmsCredit){
          setDisableSmsSend(true);
        }
      }
      setLoadingSpinner(false);
    })
  }

  const toggleDetailsModal = () => {
    setDetailsModal(!detailsModal);
  }


  const handleSendSms = (smslog) => {
    let url = URL.sendSms;
    let data = {
      smsLogId: smslog.id
    }
    axiosPost(url, data, (response) => {
      if (response.status === 200) {
        swal("Success", "SMS has been queued for sending.");
        getSmsLog(smsStatus,sentDate,searchText);
      } else {
        displayErrorAlert(response);
      }
    })

  }

  const renderSentStatus = (logData) => {
    return (
      <div
        className={logData.sentStatus == smsSentStatus.Sent
            ? "tt-chip-green": logData.sentStatus == smsSentStatus.Draft ? "tt-chip-yellow" : logData.sentStatus == smsSentStatus.Queued ? "tt-chip-blue" : "tt-chip-red"
        }
      >
        {logData.sentStatus}
      </div>
    )
  }

  const handleResetSearch = () => {
    setSmsStatus("");
    setSentDate("");
    setSearchText("");
    getSmsLog("","","");
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    switch (name) {
      case "smsStatus":
        setSmsStatus(value);
        break;
      case "sentDate":
        setSentDate(value);
        break;
      case "searchText":
        setSearchText(value);
        break;
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getSmsLog(smsStatus,sentDate,searchText,page);
  }
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      getSmsLog(smsStatus,sentDate,searchText,currentPage - 1);
    }
  };
  const handleNextPage = () => {
    if (currentPage < totalRecords / pageSize) {
      setCurrentPage(currentPage + 1);
      getSmsLog(smsStatus,sentDate,searchText,currentPage + 1);
    }
  };

  const truncatedMessage = (text, limit) => {
    if (!text) {
      return '';
    }
    if (text.length > limit) {
      return text.substring(0, limit) + '...';
    }
    return text;
  };
  return (
    <>
      {spinner ? (
        <div className="fullWindow-Spinner">
          <div>
            <Spinner color="white"></Spinner>
          </div>
          <div style={{ fontSize: "16px", marginTop: "15px" }}>
            Please wait !! Processing.....
          </div>
        </div>
      ) : null}
      {/* <x dataColumns={dataColumns} dataRows={smsLogData} /> */}
      <div className="tt-widgetContent-tab-holder" style={{ height: "79.5vh" }}>
        <div className="tt-group-header">Search SMS</div>

        <div className="row mt-2 p-2">
            <div className="col-md-4">
              <div>
                <strong>Search Text</strong>
              </div>
              <input
            type="text"
            className="form-control"
            name="searchText"
            onChange={handleChange}
            value={searchText}
            placeholder="Enter text to search"
          ></input>
            </div>
            <div className="col-md-4">
              <div>
                <strong>Sent Date</strong>
              </div>
            <NepaliDatePicker
              placeholder="Enter notify date"
              type="input"
              calendarMode={localStorage.getItem('calendar-mode')}
              showToggle={true}
              showNationalHoliday={false}
              events={[]}
              onDateSelect={(date) => {
                handleChange(
                  {
                    target: { value: date.ad.date, name: "notifsentDateyDate" },
                  },
                )
              }
              }
              value={sentDate}
            /> 
            </div>

            <div className="col-md-4">
              <div>
                <strong>Status</strong>
              </div>
              <select
            name="smsStatus"
            onChange={(e) =>handleChange(e)}
            className="form-control"
            value={smsStatus}
          >
            <option value="" selected disabled>
              Choose Sent Status
            </option>
            <option value={smsSentStatus.Sent}>{smsSentStatus.Sent}</option>
            <option value={smsSentStatus.Draft}>{smsSentStatus.Draft}</option>
            <option value={smsSentStatus.Queued}>{smsSentStatus.Queued}</option>
            <option value={smsSentStatus.Failed}>{smsSentStatus.Failed}</option>
          </select>
            </div>

      </div>
      <div className="row mt-2 p-2">
        <div className="col text-right mt-2 d-flex justify-content-end align-items-end">
          <button
            className="tt-button tt-button-danger"
            onClick={handleResetSearch}
          >
            Reset
          </button>
          <button
            className="tt-button tt-button-primary"
            onClick={getSmsLog}
          >
            Search
          </button>
        </div>
</div>
        <div
          className="tt-newListBox mb-1"
          style={{
            height: "58.5vh",
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          {loadingSpinner ? (
            <div className="text-center">
              <Spinner color="primary"></Spinner>
            </div>
          ) : smsLogData.length > 0 ? (
            <>
              <table className="table table-bordered table-striped">
                <thead className="tt-group-header">
                  <tr>
                      <th style={{ width: "27vw" }}>Message</th>
                      <th style={{ width: "9vw" }}>Sent On</th>
                      <th style={{ width: "7vw" }}>Credit Used</th>
                      <th style={{ width: "15vw" }}>Remark</th>
                      <th style={{ width: "10vw" }}>Status</th>
                      <th style={{ width: "11vw" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {smsLogData?.map((logData) => (
                    <tr>
                      <td>{truncatedMessage(logData.message, 80)}</td>
                      <td>
                        {logData?.sentDate && moment(logData?.sentDate).format("yyyy-MM-DD, hh:mm A")}
                      </td>
                      <td>{logData.creditUsed}</td>
                      <td>{logData?.remark ?? "-"}</td>
                      <td>
                        {renderSentStatus(logData)}
                      </td>
                      <td>
                        <button
                          className="tt-button tt-button-primary ml-3"
                        onClick={() =>
                          {
                            setDetailsMessage(logData.message);
                            setDetailsSentStatus(logData.sentStatus);
                            setDetailLog(logData.sendSmsTo);
                            toggleDetailsModal();
                          }
                        }
                        >
                          Details
                        </button>
                        {(logData.sentStatus == smsSentStatus.Draft
                        || logData.sentStatus == smsSentStatus.Failed )
                        &&(

                          <button
                          disabled={disableSmsSend}
                          className="tt-button tt-button-primary ml-3"
                        onClick={() => handleSendSms(logData)}
                        >
                         {logData.sentStatus == smsSentStatus.Failed ? "Retry" : "Send"}
                        </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          ) : (
            <div className="text-center p-2">
              No records found for your search parameters!!
            </div>
          )}
        </div>

        {/* <ModalWindow
        modal={this.state.editRemModal}
        modalHeader="Update Reminder"
        toggleModal={this.toggleUpdateModal}
        modalBody={
          <Reminder
            updateRemData={this.state.updateRemData}
            editMode={true}
            toggleUpdateModal={this.toggleUpdateModal}
            getAllNotifications={this.getAllNotifications}
          />
        }
        size="lg"
      ></ModalWindow>
      */}
        <ModalWindow
          modal={detailsModal}
          toggleModal={toggleDetailsModal}
          modalHeader="Sms Details"
          modalBody={
            <SmsDetails
              detailLog={detailLog}remark
              sentStatus = {detailsSentStatus}
              message={detailsMessage}
            />
          }
          size="xl"
        ></ModalWindow>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Pagination
          itemsCount={totalRecords}
          pageSize={pageSize}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          previousPage={handlePreviousPage}
          nextPage={handleNextPage}
        />
      </div>
    </>
  )
}

export default ListSMSLog